"use client";

import classNames from "classnames";
import Link, { LinkProps } from "next/link";
import { usePathname } from "next/navigation";
import { HTMLProps } from "react";

type ActiveLinkProps = {
  activeClassName: HTMLProps<HTMLElement>["className"];
  className?: string;
  children?: React.ReactNode;
  matchSubPaths?: boolean;
  isActive?: boolean;
} & LinkProps;

const ActiveLink = ({
  activeClassName,
  children,
  className,
  href,
  matchSubPaths,
  isActive: isActiveProp,
  ...rest
}: ActiveLinkProps) => {
  const pathname = usePathname();

  const hrefStr = typeof href === "string" ? href : "";
  const isActive =
    isActiveProp ??
    (pathname === hrefStr ||
      (matchSubPaths &&
        hrefStr !== "/" &&
        hrefStr !== "#" &&
        pathname.startsWith(`${hrefStr}/`)));

  return (
    <Link
      {...rest}
      href={href}
      className={classNames("!opacity-100", className, {
        [activeClassName!]: isActive,
      })}
      aria-current={isActive ? "page" : undefined}
    >
      <span className="">{children}</span>
    </Link>
  );
};

export default ActiveLink;
